import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, X } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito tener resultados perfectos para compartir mi historia?',
    a: 'No. Lo que buscamos es tu historia honesta. Las transformaciones reales, con sus altibajos, son las que más conectan con otras mujeres. Lorena lleva 25 años escuchando historias reales — no buscamos perfección, buscamos verdad.'
  }, {
    q: '¿Van a publicar mi nombre y foto sin preguntarme antes?',
    a: 'Jamás. Tú decides exactamente qué se comparte y cómo. Puedes aparecer con tu nombre real, solo tu nombre de pila, de forma completamente anónima, o simplemente como inspiración interna de la comunidad. Tú tienes el control total, siempre.'
  }, {
    q: '¿Tengo que haber completado el programa de 90 días?',
    a: 'No es requisito. Si estás en proceso, si apenas empezaste, o si tu transformación fue parcial, tu historia igual vale e inspira. Lorena cree que cada etapa del camino tiene su propio poder.'
  }, {
    q: '¿Qué hacen exactamente con mi testimonio?',
    a: 'Con tu autorización puede aparecer en: el ebook gratuito de RenuevaTE_90, redes sociales de Lorena Pérez, correos a la comunidad, y materiales educativos. Siempre con respeto, siempre con propósito, nunca de forma engañosa ni exagerada.'
  }, {
    q: '¿Cuánto tiempo toma llenar el formulario?',
    a: 'Entre 8 y 15 minutos. No hay respuestas incorrectas. No hay extensión mínima requerida. Escribe lo que sientas, con tus palabras, a tu ritmo.'
  }, {
    q: '¿Puedo retirar mi autorización después de enviarla?',
    a: 'Sí, siempre y sin explicaciones. Solo escríbeme directamente y retiro tu testimonio en máximo 7 días hábiles. Tu tranquilidad es lo primero.'
  }];
  return <section className="py-24 px-6 bg-pearl-white" data-id="element-65">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-66">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-champagne-gold font-montserrat font-semibold text-sm tracking-[0.2em] uppercase mb-4 text-center" data-id="element-67">
          Resolvemos Tus Dudas
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-playfair font-bold text-deep-blue text-3xl md:text-[42px] leading-[1.2] text-center mb-12" data-id="element-68">
          Preguntas que Quizás
          <br data-id="element-69" />
          Tienes Ahora Mismo
        </motion.h2>

        <div className="w-full space-y-4" data-id="element-70">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-71" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`border border-[#E8E8F0] rounded-xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-[#EEF2FF]' : 'bg-white'}`} data-id="element-72">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 md:p-6 text-left focus:outline-none" data-id="element-73">
        <span className="font-montserrat font-semibold text-deep-blue text-base md:text-lg pr-4" data-id="element-74">
          {question}
        </span>
        <span className="text-champagne-gold shrink-0" data-id="element-75">
          {isOpen ? <X size={24} data-id="element-76" /> : <Plus size={24} data-id="element-77" />}
        </span>
      </button>
      <AnimatePresence data-id="element-78">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-79">
            <div className="px-5 md:px-6 pb-6 pt-0" data-id="element-80">
              <div className="w-12 h-[2px] bg-champagne-gold mb-4" data-id="element-81"></div>
              <p className="font-montserrat text-gray-text text-[15px] leading-relaxed" data-id="element-82">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}